module.exports = __webpack_public_path__ + "static/media/Help_Product_Upload_small_Nov 23, 2020 12_55 PM.3d4a9d47.gif";